import { hexFromStr, invertColor } from '@/utils/S'
import dayjs, { type Dayjs } from 'dayjs'

const FRIDAY = 5

/** Ant Design DatePicker disabledDate：非周五返回 true（不可选） */
export function disabledNonFriday(currentDate: Dayjs | null | undefined): boolean {
  if (currentDate == null) {
    return false
  }
  return dayjs(currentDate).day() !== FRIDAY
}

type Props = {
  onlyFridayAvailable: (currentDate: Dayjs) => boolean
  arrayToObject: <T>(arr: T[], asKey: string) => Record<string, T>
  stringToColor: (str: string) => {
    color: string
    backgroundColor: string
  }
}

function useFormatData(): Props {
  const hexStringToRGB = (hexString) => {
    let rgb = hexString.match(/([\w\d]{2})/g).map((item) => parseInt(item, 16))
    return {
      r: rgb[0],
      g: rgb[1],
      b: rgb[2]
    }
  }

  return {
    onlyFridayAvailable: disabledNonFriday,
    arrayToObject: <T>(arr, asKey) => {
      if (!Array.isArray(arr)) {
        return {}
      }
      return arr.reduce((next, curr) => {
        return { ...next, [curr[asKey]]: curr }
      }, {})
    },
    stringToColor: (str) => {
       
      const backGroundColor = hexFromStr(str);
      const color = invertColor(backGroundColor);

      return {
        color: color,
        backgroundColor: backGroundColor
      }
    }
  }
}

export default useFormatData
